/**
 * @generated SignedSource<<1c26d991982ad3ec8bb405f81fd77d6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAddToCartButton_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButton_item">;
  readonly " $fragmentType": "PdpSharedAddToCartButton_item";
};
export type PdpSharedAddToCartButton_item$key = {
  readonly " $data"?: PdpSharedAddToCartButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAddToCartButton_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShoppingButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "94a243876016b8e627155004f1ffe4b7";

export default node;
